import { EEstimationTargets } from '@cian/valuation-main-filters-widget';

import { getFiltersQs } from './getFiltersQs';
import { trackCalculateClick } from '../../analytics';
import { PATH_FOR_AGENT_REPORT, PATH_FOR_ALL_USERS } from '../../constants/pathsEstimation';
import { TThunkAction } from '../../types/redux';
import { navigateToPage } from '../../utils/navigateToPage';

export const submitValuationForm = (): TThunkAction => (dispatch, getState) => {
  const state = getState();
  const {
    filters,
    page,
    checkEstimationExists: { estimationId, offer },
    user: { isAgent },
  } = state;
  const { address, roomsCount, area, estimationTarget, pushEnabled, houseId } = filters;

  const queryString = getFiltersQs({ filters, estimationId, offer, isAgent });

  trackCalculateClick({
    page,
    queryString,
    estimationTarget,
    houseId,
    address,
    area,
    roomsCount,
    pushEnabled,
    pushNotificationsAllowed: page.pushNotificationsAllowed,
  });

  let path: string;

  /** Если юзер выбрал оценку ЖК, или он не является агентом, тогда должен быть обычный url */
  if (estimationTarget === EEstimationTargets.newbuilding || !isAgent) {
    path = PATH_FOR_ALL_USERS;
  } else {
    /** Иначе, если юзер оценивает Квартиру и является агентом, то его нужно редиректить в Риелторский отчет */
    path = PATH_FOR_AGENT_REPORT;
  }

  navigateToPage(`${path}?${queryString}`);
};
